import { useEffect } from 'react';
export default function useVisibilityChange(target, onChange) {
  useEffect(function () {
    var observer = new IntersectionObserver(function (entries) {
      onChange(entries[0].intersectionRatio > 0);
    }, {
      root: document.body
    });

    var observe = function observe() {
      if (target.current) {
        observer.observe(target.current);
      }
    };

    var unobserve = function unobserve() {
      if (target.current) {
        observer.unobserve(target.current);
      }
    };

    observe();
    return unobserve; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target.current]);
}